import { createVanIconComponent } from "./van"

const CashBackRecord = createVanIconComponent("cash-back-record")
export default CashBackRecord
